module.exports = __webpack_public_path__ + "static/img/12.54d9518.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/imgs/12.png
// module id = maBE
// module chunks = 0